import { NgModule } from '@angular/core';
import { FormatPhoneNumbersPipe } from './format-phone-numbers.pipe';

@NgModule({
   declarations: [FormatPhoneNumbersPipe],
   exports: [FormatPhoneNumbersPipe],
   providers: [FormatPhoneNumbersPipe],
})
export class FormatPhoneNumbersPipeModule {}
